import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { CURRENT_API_YEAR } from '@/lib/season';
import { useLeagueConfig } from '@/hooks/useLeagueConfig';

interface CompetitionTeam {
  id: number;
  name: string;
  code: string;
  logo: string;
  founded: number;
  venue: {
    id: number;
    name: string;
    address: string;
    city: string;
    capacity: number;
    surface: string;
    image: string;
  };
}

export const useTeams = (season: string = CURRENT_API_YEAR) => {
  const { competitionId, competition } = useLeagueConfig();

  return useQuery({
    queryKey: ['teams', season, competitionId],
    queryFn: async () => {
      console.log(`Fetching ${competition.name} teams for season ${season}`);

      const { data, error } = await supabase.functions.invoke('fetch-teams', {
        body: { season, competitionId }
      });

      if (error) {
        console.error(`Error fetching ${competition.name} teams:`, error);
        throw error;
      }

      return data as { teams: CompetitionTeam[]; season: string; totalTeams: number; competitionId?: number };
    },
    enabled: competitionId != null,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};
